import { __cProductService } from '@/services/client/__c.product.service'
import { useMutation, useQuery } from '@tanstack/react-query'

export function useRecentProductsQuery(limit?: number) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['recentProducts', limit],
    queryFn: () => __cProductService.getRecentProducts(limit),
    notifyOnChangeProps: 'all',
  })

  return {
    recentProducts: data,
    isLoading,
    isError,
    error,
  }
}

export function useSaveRecentProduct() {
  return useMutation({
    mutationFn: (productId: string) =>
      __cProductService.saveRecentProduct(productId),
  })
}
